import React from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  background: white;
  border-radius: 24px;
  padding: 24px;
  width: 320px;
  height: 180px;
  max-width: 90vw;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const BotaoFechar = styled.button`
  position: absolute;
  top: 12px;
  right: 16px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 4px;
  
  &:hover {
    color: #333;
  }
`;

const Titulo = styled.h3`
  font-family: 'Roboto', sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: #333;
  margin: 0 0 8px 0;
  text-align: center;
`;

const Mensagem = styled.p`
  font-family: 'Roboto', sans-serif;
  font-size: 1.1rem;
  color: #666;
  margin: 0 0 16px 0;
  text-align: center;
  line-height: 1.4;
`;

const ContainerBotoes = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`;

const BotaoConfirmar = styled.button`
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 5px 50px;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #45a049;
  }
`;

const BotaoCancelar = styled.button`
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 5px 50px;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #da190b;
  }
`;

const ModalConfirmacao = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  titulo = "Confirmar Exclusão",
  mensagem = "Deseja confirmar a exclusão da designação?"
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <Overlay onClick={handleOverlayClick}>
      <ModalContainer>
        <BotaoFechar onClick={onClose}>×</BotaoFechar>
        <Mensagem>{mensagem}</Mensagem>
        <ContainerBotoes>
          <BotaoConfirmar onClick={onConfirm}>SIM</BotaoConfirmar>
          <BotaoCancelar onClick={onClose}>NÃO</BotaoCancelar>
        </ContainerBotoes>
      </ModalContainer>
    </Overlay>
  );
};

export default ModalConfirmacao;
